import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '../../../components/DemoContainer/DemoContainer';
import dayjs from "dayjs";
import { addJobPost } from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { toast } from "react-toastify";

type FormValues = {
    title: string
    description: string
    location: string
    shiftType: number
    date: any
}

const AddPost = ({getPosts, setOpen}: any) => {
    const {state} = useAuth();
    const [expDate, setExpDate] = useState<any>(dayjs());

    const {register, handleSubmit, formState: {errors}} = useForm<FormValues>();

    const onSubmit = async (data: any) => {
        const response = await addJobPost(state.user?.token, {
            title: data.title,
            description: data.description,
            jobDate: expDate,
            location: data.location,
            shiftType: data.shiftType
        })
        if(response) {
            toast.success('Job Post added successfully');
            getPosts();
            setOpen(false);
        }
    }

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {xs: "1fr", md: "1fr"},
                gap: 3
            }}>
            <Typography sx={{ fontWeight: "600" }}>Add New Post</Typography>
            <TextField
                label="Title"
                size="small"
                error={!!errors.title}
                {...register("title", {
                    required: "Title is required"
                })}
            />
            <TextField
                label="Description"
                size="small"
                multiline
                rows={4}
                error={!!errors.description}
                {...register("description", {
                    required: "Description is required"
                })}
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                    <DatePicker
                        slotProps={{textField: { size: 'small', fullWidth: true }}}
                        label="Date"
                        value={expDate}
                        format="DD/MM/YYYY"
                        onChange={(value) => setExpDate(value)}
                    />
                </DemoContainer>
            </LocalizationProvider>
            <TextField
                label="Location"
                size="small"
                error={!!errors.location}
                {...register("location", {
                    required: "Location is required"
                })}
            />
            <TextField
                select
                id="demo-select-small"
                size="small"
                label="Shift Type"
                sx={{ mb: 4 }}
                error={!!errors.shiftType}
                {...register("shiftType", {
                    required: "Shift Type is required"
                })}
            >
                <MenuItem value={0}>Day</MenuItem>
                <MenuItem value={1}>Night</MenuItem>
                <MenuItem value={2}>Weekend</MenuItem>
            </TextField>
            <div className="center-button-div">
                <Button
                    variant="contained"
                    sx={{boxShadow: 'none', width: 150}}
                    onClick={handleSubmit(onSubmit)}
                >
                    Save
                </Button>
            </div>
        </Box>
    );
}

export default AddPost;